function panelBetween(a, b, width, thickness = 0.03, lift = 8e-3) {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const length = Math.hypot(dx, dy);
  const normalX = dy / length;
  const normalY = -dx / length;
  return {
    position: [
      (a[0] + b[0]) / 2 + normalX * lift,
      (a[1] + b[1]) / 2 + normalY * lift,
      0
    ],
    rotation: [0, 0, Math.atan2(dy, dx)],
    args: [length, thickness, width]
  };
}
function beamBetween(a, b, { z = 0, thickness, depth }) {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  return {
    position: [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2, z],
    rotation: [0, 0, Math.atan2(dy, dx)],
    args: [Math.hypot(dx, dy), thickness, depth]
  };
}
export {
  beamBetween,
  panelBetween
};
